import { TechDocWizardPage } from '../containers/pages';
import { ALLETRA9k_VIDEO_URL } from '../constants';
import { powerupInit } from './alletra9kPagesConfigCommon';
import { gettingStarted } from './pageConfigComm';
import { TechDocPage } from '../containers/pages';

const physicalInstallPath = '/physical-install/';
const factoryCablePath = `${physicalInstallPath}cable/`;
const factoryUnboxPath = `${physicalInstallPath}unbox/`;

export const pagesConfig = [
  ...gettingStarted(),
  {
    path: physicalInstallPath,
    menuText: 'physicalInstallation',
    exact: true,
    redirectTo: factoryUnboxPath,
    submenuItems: [
      {
        path: factoryUnboxPath,
        menuText: 'unbox',
        exact: true,
        redirectTo: `${factoryUnboxPath}1`,
      },
      {
        path: `${factoryUnboxPath}:step`,
        exact: true,
        component: TechDocWizardPage,
        pageName: 'unbox',
        pageProps: {
          steps: [
            {
              videoUrl: ALLETRA9k_VIDEO_URL.FACTORY_UNBOX_STEP1,
            },
            {
              videoUrl: ALLETRA9k_VIDEO_URL.FACTORY_UNBOX_STEP2,
            },
            {
              videoUrl: ALLETRA9k_VIDEO_URL.FACTORY_UNBOX_STEP3,
            },
          ],
        },
      },
      {
        path: factoryCablePath,
        menuText: 'cable',
        exact: true,
        redirectTo: `${factoryCablePath}1`,
      },
      {
        path: `${factoryCablePath}:step`,
        exact: true,
        component: TechDocWizardPage,
        pageName: 'cable',
        pageProps: {
          steps: [
            {
              videoUrl: ALLETRA9k_VIDEO_URL.FACTORY_CABLE_STEP1,
            },
            {
              videoUrl: ALLETRA9k_VIDEO_URL.FACTORY_CABLE_STEP2,
            },
            {
              videoUrl: ALLETRA9k_VIDEO_URL.FACTORY_CABLE_STEP3,
            },
          ],
        },
      },
      {
        path: `${physicalInstallPath}powerOn`,
        menuText: 'powerOn',
        exact: true,
        component: TechDocPage,
        pageProps: {
          videoUrl: ALLETRA9k_VIDEO_URL.POWERUPANDINIT_POWER,
        },
      },
    ],
  },
  ...powerupInit,
];
